import BubbleChartIcon from '@material-ui/icons/BubbleChart';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import React from 'react';
import { withRouter } from 'react-router-dom';
import { ENTITLEMENTS } from '../../application-core/constants';
import SlatInner from '../../core/SlatInner';
import { globalStyles as styles } from '../../core/style/gstheme';
import { checkResourceEntitlements } from '../../core/utils/utils';

class IsolatedConceptSlat extends React.Component {

    state = {
        active: false
    };

    setActive(isActive) {
        this.setState({ active: isActive });
    }

    render() {

        const { data, onSelect, classes, defaultLang, viewLang, activeConcept, icon, useWorkflow, notInComponent, addToComponent } = this.props;
        const isReadOnly = checkResourceEntitlements(data, ENTITLEMENTS.EDIT_TAXONOMY);

        let label = data.id;
        const displayLang = viewLang && data.prefLabel && data.prefLabel[viewLang] ?
            viewLang
            :
            data.prefLabel && data.prefLabel[defaultLang] ?
                defaultLang
                :
                "und";

        if (data.prefLabel && data.prefLabel[displayLang]) {
            label = Array.isArray(data.prefLabel[displayLang]) ?
                [...data.prefLabel[displayLang]].sort().join(" AND ") : data.prefLabel[displayLang];
        }

        const fallbackLang = (viewLang && viewLang !== defaultLang && displayLang === defaultLang)
            || (displayLang === defaultLang && (!data.prefLabel || !data.prefLabel[defaultLang]))
            || (displayLang === "und" && viewLang !== "und" && defaultLang !== "und")
            || label === data.id;

        let title = label;

        return (
            <div>
                <span className={classes.slatIcon}>
                    {icon}
                </span>
                <SlatInner
                    show={!isReadOnly && !data.pendingDeletion && this.state.active}
                    title={title}
                    displayLang={displayLang}
                    notInComponent={notInComponent}
                    workflowStatus={useWorkflow && "status" in data ? data.status[0] : undefined}
                    deprecated={data.deprecated}
                    selected={activeConcept === data.id}
                    fallbackLang={fallbackLang}
                    viewLang={viewLang}
                    titleTree={[]}
                    hasChildren={!isReadOnly}
                    onClick={(e) => onSelect(data.id, e)}
                    onActivate={() => this.setActive(true)}
                    onDeactivate={() => this.setActive(false)}>                    
                    {!isReadOnly && notInComponent && !data.deprecated &&
                        <Tooltip title="Add to concept scheme"
                            onClick={() => addToComponent(data.id)}>
                            <IconButton aria-label="Add to scheme" data-test="add-to-scheme" className={classes.smallIconButton} style={{ color: 'white' }}>
                                <BubbleChartIcon />
                            </IconButton>
                        </Tooltip>
                    }
                </SlatInner>
            </div >
        );
    }
}


IsolatedConceptSlat.propTypes = {
    data: PropTypes.object.isRequired,
    icon: PropTypes.object,
    viewLang: PropTypes.string,
    notInComponent: PropTypes.bool,
    addToScheme: PropTypes.func,
    useWorkflow: PropTypes.bool,
    isOver: PropTypes.bool,
    position: PropTypes.number,
    activeConcept: PropTypes.string,
    defaultLang: PropTypes.string.isRequired,
    onSelect: PropTypes.func.isRequired,
    classes: PropTypes.object
};

export default withRouter(withStyles(styles)(IsolatedConceptSlat));